import { render, staticRenderFns } from "./InstructorDetail.vue?vue&type=template&id=f0090fb6&scoped=true"
import script from "./InstructorDetail.vue?vue&type=script&lang=ts"
export * from "./InstructorDetail.vue?vue&type=script&lang=ts"
import style0 from "./InstructorDetail.vue?vue&type=style&index=0&id=f0090fb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0090fb6",
  null
  
)

export default component.exports